class VText {
  constructor (text) {
    this.text = text || ''
  }

  type = 'VirtualText'
}

export default VText
